module.exports = __webpack_public_path__ + "img/frame-2.8a97c8fd.png";